import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Show loading animation
const loadingElement = document.createElement('div');
loadingElement.className = 'loading';
loadingElement.innerHTML = `
  <div class="loader"></div>
`;
document.body.appendChild(loadingElement);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loading animation when app is loaded
setTimeout(() => {
  loadingElement.style.display = 'none';
}, 1000);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
